import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class ReportsPaths {
  static reports = new EnhancedPath('/report-builders');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: ReportsPaths.reports.path,
      component: lazyWithRetry(() => import('app/pages/reports')),
      pageCode: PAGE_CODES.REPORT_BUILDERS_VIEW,
    },
  ],
};

export default routesConfig;
